module.exports = __webpack_public_path__ + "static/media/eye-hide-color.4d58234c.svg";